/* @generated */

// src/assets/pictogram/upsell.tsx
import * as React from "react";
var UpsellPictogram = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M50.37 27H38V7.625L12.63 37H25v19.375L50.37 27Zm-29 6L34 18.375V31h7.63L29 45.625V33h-7.63Z",
    fill: "currentColor"
  }
));
export {
  UpsellPictogram
};
